
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 5a3 3 0 013-3h30a3 3 0 013 3v3H2V5z","fill":"#fff"}}),_c('rect',{attrs:{"x":"1.667","y":"8.333","width":"36.667","height":"23.333","rx":"2","fill":"#FFF5E8"}}),_c('rect',{attrs:{"x":"24.922","y":"40.183","width":"6.684","height":"21.176","rx":"3.342","transform":"rotate(-135 24.922 40.183)","fill":"#fff"}}),_c('path',{attrs:{"d":"M33.535 31.47l3.535-3.535a3.334 3.334 0 00-4.714-4.715l-3.535 3.537m-2.358 2.356l-3.533 3.535a3.334 3.334 0 104.713 4.717l3.535-3.532m1.769-6.486l-5.894 5.891M1.667 8.627h36.666m-22 23.04h-11a3.626 3.626 0 01-2.592-1.098 3.793 3.793 0 01-1.074-2.652v-22.5c0-.995.386-1.948 1.074-2.652a3.626 3.626 0 012.592-1.098h29.334c.972 0 1.905.395 2.593 1.098a3.794 3.794 0 011.073 2.652v11.25","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"5.417","cy":"5.417","r":"1.25","fill":"#F2994A"}}),_c('circle',{attrs:{"cx":"9.583","cy":"5.417","fill":"#F2994A","r":"1.25"}}),_c('circle',{attrs:{"cx":"13.75","cy":"5.417","fill":"#F2994A","r":"1.25"}})])
          )
        }
      }
    